import { Response } from "../../interfaces/services/Response";
import { getTokenClientes } from "../../Store/storages/AuthenticationStorage";
import { apiClientes } from "../../config/api";
import { middlewareAtalhosItems, middlewareMenuItems } from "./middlewares";
import { MenuItem } from "../../interfaces/Home/MenuItem";
import { MenuMapaItem } from "../../interfaces/entities/MapaDoSite";
import { RetornaAceiteTermoResponse } from "../../interfaces/entities/RetornaAceiteTermoResponse";
import { AxiosError } from "axios";

export const getHomeData = async (): Promise<{ menu: MenuItem[], atalhos: MenuItem[] }> => {
  try {
    const token = await getTokenClientes();
    const headers = { Authorization: `Bearer ${token}` };

    const response = await apiClientes.get(`/Home/GetHomeBeneficiario`, { headers });

    if (response?.data?.menus && response?.data?.atalhos) {
      return {
        menu: response.data.menus.map(middlewareMenuItems),
        atalhos: response.data.atalhos.map(middlewareAtalhosItems),
      };
    } else {
      throw new Error('Erro ao carregar os dados');
    }
  } catch (error: any) {
    throw new Error(error.response || 'Erro inesperado');
  }
};

export const getAllAtalhos = async (): Promise<MenuItem[]> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get(`/Home/GetSelectMenulBeneficiario`,
        { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
      if (response?.data) {
        resolve(response.data.map(middlewareAtalhosItems));
      } else {
        reject(response);
      }
    } catch (error: any) {
      reject(error.response);
    }
  })
};

export const saveAtalhos = async (atalhos: MenuItem[]): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.post(
        '/Home/CadastroAtalhoMenu',
        atalhos,
        { headers: { Authorization: `Bearer ${await getTokenClientes()}` } }
      );

      if (response?.data) {
        resolve(response.data);
      } else {
        reject(response);
      }
    } catch (error: any) {
      reject(error.response || error);
    }
  });
};

export const getMensagemRestricao = async (component: string): Promise<Response> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get(`/Home/GetMensagemRestricao?component=${component}`,
        { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
      resolve(response);
    } catch (error: any) {
      reject(error.response);
    }
  })
};

export const getMenuMapaDoSite = async (): Promise<MenuMapaItem[]> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get(`/Home/GetHomeBeneficiario`,
        { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
      if (response?.data?.menus) {
        resolve(response.data.menus);
      } else {
        reject(response);
      }
    } catch (error: any) {
      reject(error.response);
    }
  })
};

export const getMostrarNovamenteBemVindo = async (): Promise<RetornaAceiteTermoResponse> => {
  try {
    const Authorization = `Bearer ${await getTokenClientes()}`;
    const headers = { Authorization };
    const response = await apiClientes.get("/Home/GetMostrarNovamenteBemVindoInic", { headers });
    return response.data;
  } catch (error) {
    throw (error as AxiosError)?.response?.data;
  }
};